// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3jSg_","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3_u1g"};